import styled, { css, keyframes } from 'styled-components';

const linePxWidth = 3;

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: ${linePxWidth}px;
  background: ${({ theme }) => theme.colors.black};
  border-radius: ${linePxWidth / 2}px;
  transition: all ${({ theme }) => theme.transitions.normal};
  position: relative;
  transform-origin: 1px;
`;

interface BurgerButtonProps {
  isActive: boolean;
}

export const BurgerButton = styled.button<BurgerButtonProps>`
  ${({ theme, isActive }) => css`
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 1.5rem;
    height: 1.5rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0.25rem 0;
    z-index: 10;
    transition: transform 0.3s ease-in-out;

    &:focus {
      outline: 2px solid ${theme.colors.accent};
      outline-offset: 2px;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      display: flex;
    }

    ${isActive &&
    css`
      transform: rotate(90deg);
    `}
  `}
`;

interface MobileContentProps {
  isVisible: boolean;
  headerHeight?: number;
}

export const MobileContent = styled.div<MobileContentProps>`
  ${({ theme, isVisible, headerHeight }) => css`
    position: fixed;
    top: ${headerHeight}px;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 25rem;
    background-color: ${theme.colors.white}DD;
    backdrop-filter: blur(8px);
    z-index: 999;
    padding: 2rem;
    box-shadow: -4px 0 10px rgba(0, 0, 0, 0.1);
    visibility: ${isVisible ? 'visible' : 'hidden'};
    animation: ${isVisible ? slideIn : slideOut} 0.3s ease-in-out forwards;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      display: block;
    }

    @media only screen and (min-width: ${theme.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const MobileMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  animation: ${fadeIn} 0.3s ease-in-out 0.2s forwards;
  opacity: 0;
`;

export const MobileMenuItem = styled.li`
  margin-bottom: 1.5rem;
  opacity: 0;
  transform: translateY(10px);
  animation: ${fadeIn} 0.3s ease-in-out forwards;

  &:nth-child(1) {
    animation-delay: 0.1s;
  }
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.3s;
  }
  &:nth-child(4) {
    animation-delay: 0.4s;
  }
  &:nth-child(5) {
    animation-delay: 0.5s;
  }
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 0.5rem;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      column-gap: 0.5rem;
    }
  `}
`;
